import React from 'react';
import { Handle, Position } from 'reactflow';

export default function StartNode({ data }) {
  return (
    <div
      className="start-node"
      style={{
        padding: '10px 16px',
        backgroundColor: '#22c55e', // green
        color: 'white',
        borderRadius: 12,
        fontWeight: 'bold',
        textAlign: 'center',
        minWidth: 100,
        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
        position: 'relative',
      }}
    >
      Start

      {/* Bottom handle to connect to next node */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="start-bottom"
        style={{
          background: '#fff',
          border: '2px solid #fff',
          width: 16,
          height: 16,
          borderRadius: '50%',
          bottom: -8,
        }}
      />
    </div>
  );
}
